var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CDotButton"},_vm._l((_vm.dotList),function(item){return _c('div',{key:item,staticClass:"cdb-dot",class:{ active: _vm.active === item },on:{"click":function($event){return _vm.click(item)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }